export default __webpack_public_path__ + "static/12-28c649174e1c53092251c6cd7ab1ed7c.png";